import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class FileUploaderService {

  constructor(private http: HttpClient) { }

  fileUpload(file: FormData) {

    return this.http.post('http://localhost:5000/rhAPI/uploadRaterPic', file);

  }

  updatePicStatus(lid: any){
  }





}
